// Custom Attribute Types

export interface CustomAttributeDefinitionDTO {
  id: string;
  company_id: string;
  attribute_key: string;
  label: string;
  data_type: 'text' | 'number' | 'boolean' | 'date' | 'datetime';
  is_required: boolean;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateCustomAttributeDefinitionDTO {
  attribute_key: string;
  label: string;
  data_type: 'text' | 'number' | 'boolean' | 'date' | 'datetime';
  is_required: boolean;
  display_order?: number;
}

export interface UpdateCustomAttributeDefinitionDTO {
  label?: string;
  is_required?: boolean;
  display_order?: number;
}

export interface CustomAttributeValueDTO {
  attribute_key: string;
  value: string | number | boolean | Date;
}

export interface CustomAttributeValueInputDTO {
  attribute_key: string;
  value: string | number | boolean | Date;
}

export interface CustomAttributeDefinitionListRequestDTO {
  page?: number;
  limit?: number;
  search?: string;
  data_type?: string;
  is_active?: boolean;
}

export interface PaginatedCustomAttributeDefinitionResponseDTO {
  page: number;
  limit: number;
  total: number;
  data: CustomAttributeDefinitionDTO[];
}

export const DATA_TYPE_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Yes/No' },
  { value: 'date', label: 'Date' },
  { value: 'datetime', label: 'Date & Time' },
] as const;

